import React from 'react';
import clsx from 'clsx';
import { Table, Icon } from 'semantic-ui-react';

const TableErrorRow = ({
  numberOfColumns,
  className,
  error,
  onErrorDismiss,
}) => {
  if (!error) {
    return null;
  }

  return (
    <Table.Row verticalAlign="middle" error className={clsx('aridhia-error-row', className)}>
      <Table.Cell colSpan={numberOfColumns}>
        {error.message}
        <Icon name="close" link className="float-r" onClick={onErrorDismiss} />
      </Table.Cell>
    </Table.Row>
  );
};

export default TableErrorRow;
